import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/close_icon.png'
import _imports_1 from '@/assets/common/pwa_update_banner.png'
import _imports_2 from '@/assets/common/pwa_update_icon1.png'
import _imports_3 from '@/assets/common/pwa_update_icon2.png'
import _imports_4 from '@/assets/common/0029_kefu2_bai.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { style: {"padding":"0 20px"} }
const _hoisted_3 = { class: "detailsBg" }
const _hoisted_4 = { class: "infoText" }
const _hoisted_5 = { style: {"white-space":"pre-line"} }
const _hoisted_6 = { class: "bonusBar" }
const _hoisted_7 = { class: "linkBtn" }

import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user'
import ContactServicePopup from '@/view/profile/contactServicePopup.vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import {
  openPopup,
  closePopup,
  showError,
  showSuccess,
  openContactPopup,
  goToPlayStore
} from '@/view/components/supportFunction'


export default /*@__PURE__*/_defineComponent({
  __name: 'pwaAntiBlockingPopup',
  emits: ['close', 'success', 'error'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t } = useI18n()
const emits = __emit

const userStore = useUserStore()
const show = ref(false)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const contactRef = ref()

const activityInfo = computed(() => userStore?.PWAConvertData?.config?.popupMessage)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const rewardCoin = computed(() => userStore?.PWAConvertData?.config?.rewardCoin)
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const timeDuration = computed(() => userStore?.PWAConvertData?.config?.popupDuration)
const pwaID = computed(() => userStore?.PWAConvertData?.config?.Id)
const pwaDomainInfo = computed(() => userStore?.PWAdomainInfo)

const params = {
  show,
  contactRef,
  statusRef,
  loadingRef,
  toastContent,
  isSuccess,
  userStore,
  isOpen,
  canReceivedRewards: canRecievedRewards,
  timeDuration,
  pwaID,
  pwaDomainInfo,
  emits,
  t
}

const open = () => openPopup(params)
const close = () => closePopup(params)
const handleContact = () => openContactPopup(params)
const handlePlayStore = () => goToPlayStore(params)

__expose({ open, close })

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      onClose: close,
      position: "center",
      style: {
        minWidth: '70%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        zIndex: '10000'
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", { class: "closeIcon" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              onClick: close
            })
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bannerImg" }, [
            _createElementVNode("img", {
              src: _imports_1,
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(activityInfo.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              }, null, -1)),
              _createElementVNode("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('pwa.bonuses')) + " ", 1),
                _createElementVNode("span", null, "R$ " + _toDisplayString(rewardCoin.value), 1)
              ])
            ]),
            _createVNode(_component_van_row, { style: {"padding":"5px 0 15px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "18",
                  class: "alignment"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[2] || (_cache[2] = _createElementVNode("img", {
                        src: _imports_3,
                        alt: ""
                      }, null, -1)),
                      _createElementVNode("div", { onClick: handlePlayStore }, _toDisplayString(_ctx.$t('pwa.updateNow')), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_van_col, {
                  span: "6",
                  class: "alignment"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "serviceIcon",
                      onClick: handleContact
                    }, _cache[3] || (_cache[3] = [
                      _createElementVNode("img", {
                        src: _imports_4,
                        alt: ""
                      }, null, -1)
                    ]))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(ContactServicePopup, {
      ref_key: "contactRef",
      ref: contactRef
    }, null, 512),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})